import { render, staticRenderFns } from "./Create-Question.vue?vue&type=template&id=9c9e61c4"
import script from "./Create-Question.vue?vue&type=script&lang=js"
export * from "./Create-Question.vue?vue&type=script&lang=js"
import style0 from "./Create-Question.vue?vue&type=style&index=0&id=9c9e61c4&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports